var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMergeTables(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 9,
    viewBox: "0 0 11 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H0.515625H2.0625H3.4375H3.67383L3.8457 0.214844L6.42383 3.60938H8.98047L8.14258 2.77148L7.77734 2.40625L8.50781 1.69727L8.87305 2.0625L10.5918 3.78125L10.957 4.14648L10.5918 4.51172L8.87305 6.23047L8.50781 6.5957L7.77734 5.84375L8.14258 5.47852L8.98047 4.64062H6.42383L3.8457 8.05664L3.67383 8.25H3.4375H2.0625H0.515625H0V7.21875H0.515625H2.0625H3.17969L5.52148 4.125L3.17969 1.03125H2.0625H0.515625H0V0Z",
    fill: "#3A8FD8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMergeTables);
export default __webpack_public_path__ + "static/media/merge-tables.df7316ac2568fad4f7e6a728f3656537.svg";
export { ForwardRef as ReactComponent };